import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_TOAST_TYPE = "info";
const DEFAULT_DURATION = 3000;

const initialState = {
  visible: false,
  type: DEFAULT_TOAST_TYPE, // info, error, success, warning
  primaryMessage: "",
  secondaryMessage: "",
  icon: null,
  autoHideDuration: DEFAULT_DURATION,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.visible = true;
      state.type = action.payload.type ?? DEFAULT_TOAST_TYPE;
      state.primaryMessage = action.payload.primaryMessage ?? "";
      state.secondaryMessage = action.payload.secondaryMessage ?? "";
      state.rightText = action.payload.rightText ?? "";
      state.icon = action.payload.icon ?? null;
      state.autoHideDuration = action.payload.autoHideDuration !== undefined ? action.payload.autoHideDuration : DEFAULT_DURATION;
    },
    hideToast: (state) => {
      state.visible = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;